import { SERVER_URL } from "../../../../api";

export default function ServiceOfferTab({ offer }) {

    console.log(offer);

    if (offer?.info === "pending" && !offer?.fileOfferURL && !offer.observations) {

        return (
            <div className="card" style={{ borderRadius: "4px", padding: "20px" }}>
                <div className="section-card" style={{ border: "none" }} >
                    <h4>Not offer sent yet</h4>
                </div>
            </div >
        )
    }

    return (
        <div className="container-fluid">
            <div className="row g-3">
                {offer?.fileOfferURL &&
                    <div className="card col-md-6 col-12">
                        <iframe
                            src={`${SERVER_URL}/${offer?.fileOfferURL}`}
                            width="100%"
                            height="650px"
                            title="PDF firmado"
                            style={{ border: "1px solid #ccc", marginTop: "1rem" }}
                        />
                    </div>

                }

                <div className="col-md-6 col-12 col-int-proj">
                    {offer?.observations && (
                        <div className="card mb-3" style={{ borderRadius: "4px", padding: "20px" }}>
                            <div className="section-card" style={{ border: "none" }}>
                                <h4>Observations</h4>
                                <div className="row-card" style={{ marginTop: "1rem", marginBottom: "10px" }} >
                                    <span className="label-value">{offer?.observations}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {offer?.info && offer?.info !== "pending" && (
                        <div className="card" style={{ borderRadius: "4px", padding: "20px" }}>
                            <div className="d-flex justify-content-center align-items-center gap-2">
                                <label className={`label-rejected text-uppercase ${offer?.info === "accepted" ? "primary-color" : ""}`}>OFFER {offer?.info}</label>
                            </div>

                            {offer?.info === "rejected" &&
                                <div className="section-card" style={{ border: "none" }}>
                                    <h4>Reason</h4>
                                    <div className="row-card" style={{ marginTop: "1rem", marginBottom: "10px" }}>
                                        <span className="label-value">{offer?.reasonReject}</span>
                                    </div>
                                </div>
                            }

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}